import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';

import AppSideBar from '../../nav-bar/view';
import MainAppBar from '../../app-bar/view';
import UserListScreen from '../../users-mgmt/view/UserListScreen';
import UserScreen from '../../users-mgmt/view/UserScreen';
import StationListScreen from '../../stations-mgmt/view/StationListScreen';
import StationScreen from '../../stations-mgmt/view/StationScreen';
import DashboardScreen from '../../fast-data/view/DashboardScreen';
import DMYLineGraphScreen from '../../slow-data/view/DMYLineGraphScreen';
import FastDMYLineGraphScreen from '../../station-fastdata/view/DMYLineGraphScreen';
import StationStatisticsScreen from '../../station-statistics/view/StationStatisticsScreen';
import HealthDataLiveScreen from '../../health-data/view';
import DownloadSreen from '../../download-request/view/DownloadScreen';
import ErrorReportSearchScreen from '../../error-reports/view/ReportSearchScreen';
import ForecastGraphDisplay from '../../station-forecast-data/forecast-view/ForecastDataDisplay';
import SMARTOMScreen from '../../smart-om/view/SmartOMDiaplay';
import SystemDeviceFaultsScreen from '../../system-device-faults/view/SystemDeviceFaultsDisplay'
import PortfolioFaultOverview from '../../portfolio-fault-overview/view/PortfolioFaultOverview';

import * as mainSideBarReducers from '../../nav-bar/reducer';

import * as systemActionMgr from '../../system/action-creator';
import * as systemReducer from '../../system/reducer';

import { isLoggedIn } from '../../helpers/common';

// const drawerWidth = 280;
const styles = theme => ({
  root: {
    width: '100%',
    zIndex: 1
  },
  appFrame: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '100%',
  },
  content: {
    flexGrow: 1,
    marginTop: 56,
    [theme.breakpoints.up('sm')]: {
      marginTop: 64,
    },
    [theme.breakpoints.up('lg')]: {
      // marginLeft: drawerWidth
    }
  },
});

const routesMap = {
  "/dashboard": DashboardScreen,
  "/users": UserListScreen,
  "/users/new": UserScreen,
  "/users/:userId": UserScreen,
  "/stations": StationListScreen,
  "/stations/new": StationScreen,
  "/stations/:stationId": StationScreen,
  "/station-history": DMYLineGraphScreen,
  "/station-fastdata": FastDMYLineGraphScreen,
  "/station-statistics": StationStatisticsScreen,
  "/station-forecast-data": ForecastGraphDisplay,
  "/system-device-faults": SystemDeviceFaultsScreen,
  "/portfolio-fault-overview": PortfolioFaultOverview,
  "/stations-health": HealthDataLiveScreen,
  "/station-error-reports/:stationName": ErrorReportSearchScreen,
  "/download": DownloadSreen,
  "/error-reports": ErrorReportSearchScreen
}

class Root extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let intervalId = setInterval(() => {
      if (!isLoggedIn()) {
        window.location.href = "/login";
      }
    }, 1000);
    this.props.setUserIdCheckingIntervalId(intervalId);
  }

  render() {
    const { classes, paths, getValidToken } = this.props;
    const userRoutes = paths.map(path => ({
      path,
      component: routesMap[path]
    }));

    return (
      <div className={classes.root}>
        <Router>
          <div className={classes.appFrame}>
            <MainAppBar />
            <AppSideBar />
            <main className={classes.content}>
              <Switch>
                {userRoutes.map(r => <Route key={r.path} exact path={r.path} component={r.component} />)}
                <Route render={() => <Redirect to={{ pathname: "/dashboard" }} />} />
              </Switch>
            </main>
          </div>
        </Router>
      </div>
    )
  }
}

Root.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  paths: mainSideBarReducers.getMenuPaths(state),
  getValidToken: systemReducer.getValidToken(state)
});

const mapDispatcherToProps = {
  setUserIdCheckingIntervalId: systemActionMgr.setUserIdCheckingIntervalId,
  logout: systemActionMgr.logout
}

export default connect(mapStateToProps, mapDispatcherToProps)(
  withStyles(styles)(Root)
);